import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitobangorecab() {



    const cardData = {




keyword: "Mumbai to Bangalore Cab",

headingDescription: "Shreesha Tours & Travels provides reliable, comfortable, and affordable Mumbai to Bangalore cab services for business travelers, corporate professionals, families, tourists, students, and long-distance travelers. We offer one-way cabs, round-trip taxi services, airport transfers, corporate travel, multi-city journeys, and customized outstation tour packages with experienced chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles suitable for solo travelers, families, and large groups. With doorstep pickup anywhere in Mumbai, flexible departure schedules, transparent pricing, easy online booking, and 24/7 customer support, Shreesha Tours & Travels ensures a safe, smooth, and hassle-free journey. Whether you are traveling for business meetings, IT company visits, family functions, educational purposes, medical travel, relocation, or sightseeing, our Mumbai to Bangalore cab service offers professional drivers, clean vehicles, and personalized travel solutions. Enjoy a comfortable long-distance road trip with premium travel comfort, multiple stopover options, and dependable service throughout your journey.",

topPlaces: [
  {
    title: "Lalbagh Botanical Garden",
    description: "Lalbagh Botanical Garden is one of Bangalore's most iconic attractions, spread across hundreds of acres with rare plant species, colorful flower displays, a historic glass house, lakes, and walking trails. It is a perfect destination for nature lovers, photographers, and families."
  },
  {
    title: "Cubbon Park",
    description: "Cubbon Park is a lush green oasis in the heart of Bangalore, offering landscaped gardens, tree-lined pathways, heritage buildings, jogging tracks, and recreational spaces. It is a popular destination for morning walks, relaxation, and family outings."
  },
  {
    title: "Bangalore Palace",
    description: "Bangalore Palace is a magnificent royal residence inspired by England's Windsor Castle. The palace features elegant architecture, royal artifacts, paintings, gardens, and beautifully decorated interiors, making it one of the city's top heritage attractions."
  },
  {
    title: "ISKCON Temple Bangalore",
    description: "ISKCON Temple Bangalore is one of India's largest and most beautiful Krishna temples. Known for its grand architecture, devotional atmosphere, cultural programs, and spiritual ambiance, it attracts devotees and tourists from around the world."
  },
  {
    title: "Vidhana Soudha",
    description: "Vidhana Soudha is the seat of the Karnataka State Legislature and one of Bangalore's most recognized landmarks. Its impressive Neo-Dravidian architecture and beautifully illuminated exterior make it a favorite sightseeing destination."
  },
  {
    title: "Bannerghatta Biological Park",
    description: "Bannerghatta Biological Park is a popular wildlife destination featuring a safari park, zoo, butterfly park, rescue center, and diverse wildlife including lions, tigers, elephants, and bears. It is ideal for families and wildlife enthusiasts."
  },
  {
    title: "Nandi Hills",
    description: "Nandi Hills is a scenic hill station located near Bangalore, famous for breathtaking sunrise views, cool climate, cycling routes, trekking trails, and historical significance. It is one of the city's most popular weekend getaway destinations."
  },
  {
    title: "Commercial Street",
    description: "Commercial Street is Bangalore's famous shopping destination offering fashion boutiques, footwear, jewelry, street shopping, restaurants, and local markets. It is a favorite place for shoppers and tourists exploring the city."
  },
  {
    title: "Wonderla Bangalore",
    description: "Wonderla Bangalore is one of India's best amusement parks, offering thrilling rides, water slides, wave pools, and entertainment for visitors of all ages. It is an ideal destination for family vacations and group outings."
  },
  {
    title: "Electronic City",
    description: "Electronic City is Bangalore's premier IT and technology hub, home to leading multinational companies, software parks, startups, and corporate offices. Business travelers frequently visit this area for meetings, conferences, and corporate events."
  }
],



"services": [
  {
    "name": "Mumbai to Bangalore Cab",
    "description": "Book Mumbai to Bangalore Cab for safe, comfortable, and reliable long-distance travel with experienced chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova, Innova Crysta, SUV, Kia Carens, and Tempo Traveller options for business travel, family vacations, corporate tours, airport transfers, and one way or round trip journeys. Enjoy doorstep pickup, transparent pricing, 24x7 customer support, and a smooth highway journey with professional drivers."
  },
  {
    "name": "Mumbai to Bangalore Taxi",
    "description": "Hire Mumbai to Bangalore Taxi for hassle-free interstate travel with professional drivers, comfortable seating, and clean vehicles. Our chauffeur-driven taxis are ideal for business meetings, family holidays, relocation travel, corporate trips, and personalized outstation transportation with flexible pickup and drop locations."
  },
  {
    "name": "Mumbai to Bangalore Cab Service",
    "description": "Choose Mumbai to Bangalore Cab Service for dependable outstation travel with premium AC vehicles, experienced chauffeurs, and affordable travel packages. Enjoy reliable transportation with flexible one way and round trip booking options designed for personal, business, and leisure travel."
  },
  {
    "name": "Mumbai to Bangalore Taxi Service",
    "description": "Book Mumbai to Bangalore Taxi Service for convenient interstate transportation with transparent pricing, professional drivers, and comfortable vehicles. Travel safely with multiple cab options suitable for families, tourists, and corporate travelers."
  },
  {
    "name": "Mumbai to Bangalore Cab Booking",
    "description": "Complete Mumbai to Bangalore Cab Booking online with instant confirmation, competitive pricing, and multiple vehicle choices. Select the perfect cab according to your travel requirements and enjoy comfortable doorstep pickup with experienced chauffeurs."
  },
  {
    "name": "Mumbai to Bangalore Car Rental",
    "description": "Hire Mumbai to Bangalore Car Rental with chauffeur-driven vehicles for comfortable and flexible long-distance travel. Ideal for business executives, family vacations, corporate travel, sightseeing, and interstate road trips."
  },
  {
    "name": "Mumbai to Bangalore Taxi Fare",
    "description": "Check Mumbai to Bangalore Taxi Fare with transparent pricing and affordable travel packages. Compare Sedan, Ertiga, Innova Crysta, SUV, Kia Carens, and Tempo Traveller options while enjoying reliable and comfortable transportation."
  },
  {
    "name": "Mumbai to Bangalore Cab Fare",
    "description": "Get the best Mumbai to Bangalore Cab Fare with economical pricing, premium vehicles, and experienced chauffeurs. Enjoy safe, comfortable, and budget-friendly long-distance travel without hidden charges."
  },
  {
    "name": "Mumbai to Bangalore One Way Cab",
    "description": "Book Mumbai to Bangalore One Way Cab for economical single-trip travel without paying return charges. Enjoy fixed pricing, comfortable AC vehicles, professional drivers, and reliable service for your interstate journey."
  },
  {
    "name": "Mumbai to Bangalore Round Trip Taxi",
    "description": "Reserve Mumbai to Bangalore Round Trip Taxi for convenient return travel with affordable packages, flexible schedules, and experienced chauffeurs. Perfect for business visits, family vacations, sightseeing, and extended travel."
  },
  {
    "name": "Mumbai to Bangalore Outstation Cab",
    "description": "Choose Mumbai to Bangalore Outstation Cab for smooth interstate travel with clean AC vehicles, trained drivers, and competitive pricing. Travel comfortably with premium cab options for business and leisure journeys."
  },
  {
    "name": "Mumbai Airport to Bangalore Cab",
    "description": "Book Mumbai Airport to Bangalore Cab for reliable airport pickup and direct long-distance travel with experienced chauffeurs and comfortable vehicles. Enjoy timely service from all Mumbai airport terminals with hassle-free booking."
  },
  {
    "name": "Mumbai to Bangalore Car Hire",
    "description": "Hire Mumbai to Bangalore Car Hire for private chauffeur-driven travel with spacious vehicles, flexible itineraries, and dependable customer support. Suitable for family trips, corporate travel, and personal journeys."
  },
  {
    "name": "Mumbai to Bangalore Private Taxi",
    "description": "Reserve Mumbai to Bangalore Private Taxi for personalized travel with dedicated vehicles, professional chauffeurs, complete privacy, and premium comfort. Perfect for executives, families, and VIP travel."
  },
  {
    "name": "Navi Mumbai to Bangalore Cab",
    "description": "Book Navi Mumbai to Bangalore Cab for reliable interstate transportation with experienced drivers, premium AC vehicles, and convenient pickup services. Ideal for business travelers, families, and corporate clients."
  },
  {
    "name": "Thane to Bangalore Taxi",
    "description": "Choose Thane to Bangalore Taxi for affordable and comfortable long-distance travel with professional chauffeurs and well-maintained vehicles. Enjoy smooth interstate transportation with transparent pricing."
  },
  {
    "name": "Mumbai to Bangalore Innova Cab",
    "description": "Hire Mumbai to Bangalore Innova Cab for spacious travel with comfortable seating, generous luggage capacity, and experienced chauffeurs. Perfect for families, business groups, and long-distance road trips."
  },
  {
    "name": "Mumbai to Bangalore Innova Crysta Cab",
    "description": "Book Mumbai to Bangalore Innova Crysta Cab for premium luxury travel with spacious interiors, superior comfort, and professional chauffeur service. Ideal for executive travel, family holidays, and corporate transportation."
  },
  {
    "name": "Mumbai to Bangalore Ertiga Cab",
    "description": "Reserve Mumbai to Bangalore Ertiga Cab for economical 6 to 7 seater travel with spacious interiors, comfortable seating, and reliable chauffeur service. Perfect for family vacations and group travel."
  },
  {
    "name": "Mumbai to Bangalore Sedan Cab",
    "description": "Choose Mumbai to Bangalore Sedan Cab for affordable and comfortable travel with clean AC vehicles and experienced drivers. Suitable for solo travelers, couples, business executives, and long highway journeys."
  },
  {
    "name": "Mumbai to Bangalore SUV Cab",
    "description": "Book Mumbai to Bangalore SUV Cab for premium outstation travel with spacious seating, extra luggage space, and excellent ride comfort. Ideal for large families, adventure trips, and luxury travel."
  },
  {
    "name": "Mumbai to Bangalore Kia Carens Cab",
    "description": "Hire Mumbai to Bangalore Kia Carens Cab for stylish and spacious travel with premium interiors, comfortable seating, and modern features. Enjoy a relaxing journey with professional chauffeurs and reliable service."
  },
  {
    "name": "Mumbai to Bangalore Tempo Traveller",
    "description": "Reserve Mumbai to Bangalore Tempo Traveller for group tours, family vacations, corporate outings, and pilgrimage trips. Enjoy spacious seating, experienced drivers, and comfortable long-distance travel with flexible itineraries."
  },
  {
    "name": "Mumbai to Bangalore Long Distance Taxi",
    "description": "Book Mumbai to Bangalore Long Distance Taxi for dependable interstate travel with trained chauffeurs, premium AC vehicles, and transparent pricing. Enjoy safe highway driving, comfortable seating, and convenient pickup and drop services."
  },
  {
    "name": "Reliable Mumbai Bangalore Cab Service",
    "description": "Choose Reliable Mumbai Bangalore Cab Service for trusted long-distance transportation with well-maintained vehicles, courteous chauffeurs, affordable fares, and outstanding customer support. Whether you need one way travel, round trip transportation, corporate cab service, airport transfers, family vacations, or business travel, our reliable taxi service ensures a safe, comfortable, punctual, and stress-free journey from Mumbai to Bangalore."
  }
],
"tableData": [
  ["Mumbai to Bangalore Cab", "Mumbai to Bangalore Taxi"],
  ["Mumbai to Bangalore Cab Service", "Mumbai to Bangalore Taxi Service"],
  ["Mumbai to Bangalore Cab Booking", "Mumbai to Bangalore Car Rental"],
  ["Mumbai to Bangalore Taxi Fare", "Mumbai to Bangalore Cab Fare"],
  ["Mumbai to Bangalore One Way Cab", "Mumbai to Bangalore Round Trip Taxi"],
  ["Mumbai to Bangalore Outstation Cab", "Mumbai Airport to Bangalore Cab"],
  ["Mumbai to Bangalore Car Hire", "Mumbai to Bangalore Private Taxi"],
  ["Navi Mumbai to Bangalore Cab", "Thane to Bangalore Taxi"],
  ["Mumbai to Bangalore Innova Cab", "Mumbai to Bangalore Innova Crysta Cab"],
  ["Mumbai to Bangalore Ertiga Cab", "Mumbai to Bangalore Sedan Cab"],
  ["Mumbai to Bangalore SUV Cab", "Mumbai to Bangalore Kia Carens Cab"],
  ["Mumbai to Bangalore Tempo Traveller", "Mumbai to Bangalore Long Distance Taxi"],
  ["Reliable Mumbai Bangalore Cab Service", ""]
],




whychoose: [
  {
    WhyChooseheading: "Long-Distance Mumbai to Bangalore Cab Service",
    WhyChoosedescription: "Travel comfortably between Mumbai and Bangalore with Shreesha Tours & Travels. Our private cab service is designed for business executives, families, students, tourists, and professionals looking for a reliable interstate journey."
  },
  {
    WhyChooseheading: "Convenient Door-to-Door Interstate Transportation",
    WhyChoosedescription: "Enjoy pickup from any location in Mumbai and direct drop-off anywhere in Bangalore without the hassle of changing buses, trains, or flights during your journey."
  },
  {
    WhyChooseheading: "Premium Fleet for Comfortable Road Trips",
    WhyChoosedescription: "Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles that provide excellent comfort for long-distance travel."
  },
  {
    WhyChooseheading: "Suitable for Business, Relocation & Family Travel",
    WhyChoosedescription: "Whether you're relocating, attending corporate meetings, visiting family, going on a vacation, or travelling for educational purposes, our Mumbai to Bangalore taxi service offers a dependable travel solution."
  },
  {
    WhyChooseheading: "Experienced Drivers for Interstate Highways",
    WhyChoosedescription: "Our professional chauffeurs have extensive experience driving on long interstate routes, ensuring safe driving, timely travel, and a relaxed journey throughout the trip."
  },
  {
    WhyChooseheading: "Flexible One Way, Round Trip & Multi-Day Plans",
    WhyChoosedescription: "Book one-way taxi services, return journeys, or customized multi-day travel plans with flexible pickup timings and optional stopovers along the route."
  },
  {
    WhyChooseheading: "Comfort-Focused Travel Experience",
    WhyChoosedescription: "Every cab is regularly serviced and equipped with air conditioning, comfortable seating, spacious luggage capacity, and clean interiors to make your interstate journey enjoyable."
  },
  {
    WhyChooseheading: "Trusted Mumbai to Bangalore Cab Booking",
    WhyChoosedescription: "Shreesha Tours & Travels offers transparent pricing, prompt customer support, and easy booking assistance to help you plan your journey with confidence."
  }
]

};

const faqData = [
  {
    question: "Can I travel directly from Mumbai to Bangalore by private cab?",
    answer: "Yes, Shreesha Tours & Travels offers direct private cab service from Mumbai to Bangalore with doorstep pickup and destination drop."
  },
  {
    question: "Is Mumbai to Bangalore cab suitable for relocation travel?",
    answer: "Yes, many customers choose our taxi service while relocating with family and luggage because it provides flexibility and comfort."
  },
  {
    question: "Which vehicles are recommended for long-distance Mumbai to Bangalore travel?",
    answer: "Innova Crysta, Ertiga, SUVs, Tempo Travellers, and Sedan cars are available depending on the number of passengers and luggage."
  },
  {
    question: "Can I add overnight halts during the journey?",
    answer: "Yes, customized travel plans with overnight stays and multiple stopovers can be arranged according to your itinerary."
  },
  {
    question: "Do you provide taxi service for corporate employees travelling to Bangalore?",
    answer: "Yes, our Mumbai to Bangalore cabs are suitable for business executives, IT professionals, corporate teams, and official travel."
  },
  {
    question: "Can I schedule pickup from Mumbai Airport or Navi Mumbai?",
    answer: "Yes, pickup is available from Mumbai Airport, Navi Mumbai, railway stations, hotels, offices, and residential locations."
  },
  {
    question: "Is one-way cab booking available for Mumbai to Bangalore?",
    answer: "Yes, one-way, round-trip, and customized interstate taxi services are available throughout the year."
  },
  {
    question: "How is the Mumbai to Bangalore taxi fare calculated?",
    answer: "The fare depends on the vehicle category, travel duration, trip type, and customized itinerary. A detailed quotation is provided before booking."
  },
  {
    question: "Can groups book Tempo Travellers for Bangalore trips?",
    answer: "Yes, Tempo Travellers and larger vehicles are available for family vacations, corporate groups, educational tours, and group travel."
  },
  {
    question: "What information is required to confirm a Mumbai to Bangalore cab booking?",
    answer: "Share your travel date, pickup location, destination, passenger count, luggage details, and preferred vehicle to receive your quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Akash Kulkarni",
    feedback: "I booked a Mumbai to Bangalore cab while relocating for work. The Innova Crysta was comfortable, the driver was experienced, and the entire interstate journey was managed professionally.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Nisha Rao",
    feedback: "Our family travelled from Mumbai to Bangalore with Shreesha Tours & Travels. The vehicle was clean, the ride was smooth, and the booking process was simple from start to finish.",
    rating: 5
  }
];




















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Bangalore Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-bangalore-cab.webp",
  "description":
    "Book Mumbai to Bangalore Cab with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Mumbai to Bangalore with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for business travel, corporate trips, family vacations, airport transfers, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-bangalore-cab"
  }
};





    return (
        <div>
<Helmet>
  <title>Mumbai to Bangalore Cab | Long Distance Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Bangalore Cab with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for affordable travel from Mumbai to Bangalore with 24x7 online cab booking and transparent fares."
  />

  <meta
    name="keywords"
    content="Mumbai to Bangalore Cab, Mumbai to Bangalore Taxi, Mumbai to Bangalore Cab Service, Mumbai to Bangalore Taxi Service, Mumbai to Bangalore Cab Booking, Mumbai to Bangalore Car Rental, Mumbai to Bangalore Taxi Fare, Mumbai to Bangalore Cab Fare, Mumbai to Bangalore One Way Cab, Mumbai to Bangalore Round Trip Cab, Mumbai to Bangalore Outstation Cab, Mumbai to Bangalore Taxi Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/27.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitobangorecab;